<template>
  <div class="layout" :class="layoutClass">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name:'KilokLayout',
    data(){
        return{
            layoutClass:{
                hasSider:false
            }
        }
    },
    mounted(){
        this.$children.forEach((vm)=>{
            if(vm.$options.name === 'KilokSider'){
                this.layoutClass.hasSider = true
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.layout{
    min-width: 500px;
    min-height: 400px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    &.hasSider{
        flex-direction: row;
        
    }
}
</style>